import { render, staticRenderFns } from "./InvoiceCreateUpdate.vue?vue&type=template&id=2c2cd4c3&"
import script from "./InvoiceCreateUpdate.vue?vue&type=script&lang=js&"
export * from "./InvoiceCreateUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports